module.exports = __webpack_public_path__ + "media/audio1.c4db69cb.mp3";